import React, { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CCAssessmentType, EnrollmentCertificate } from "../../../Physician/Models/CCEnrollment";
import { Certificate, CertificateStatus, CertificationGeneration } from "../../../Physician/Models/Certificate";
import Physician from "../../../Physician/Models/Physician";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";
import CCEnrollmentCertficateSummaryCard from "./CCEnrollmentCertificateSummaryCard";
import { AbccAssessment, AbccAssessmentModule } from "../Models/CCAssessment";
import { CCArticleWaiver } from "../../../Physician/Models/CCBlock";

interface IProps{
    physician: Physician;
    abccAssessments: AbccAssessment[];
    acceptAbccModuleAttestation: (abccAssessmentModule: AbccAssessmentModule) => void;
    appliedArticleWaivers: Array<CCArticleWaiver>;
}

export default function CCEnrollmentSummary(props: IProps) {
    const isEnrolledinCC = props.physician.currentCCEnrollment != null;
    const lifeTimeActiveCertificates = props.physician.certificates.filter(cert => cert.certificationGeneration === CertificationGeneration.Lifetime && cert.certificateStatus == CertificateStatus.Active);
    

    const getCcAssessmentTypeName = (ccAssessmentType: CCAssessmentType ) => {
        switch(ccAssessmentType){
            case CCAssessmentType.Exam:
                return <span>Examination Pathway</span>;
            case CCAssessmentType.Article:
                return <span>Article Based Continuing Certification (ABCC)</span>;
            default:
                return <span className="pp-font-size-smallest">ABPN's ABCC pathway is not an option for this certification. <br />Please see the <a target="_BLANK" href="https://abpn.org/maintain-certification/taking-a-cc-exam/subspecialty-cc-exams/">ABPN Website</a> for more details.</span>
        }
    }

    let activeAndFutureEnollmentCertificates = props.physician.currentCCEnrollment && Object.values(props.physician.currentCCEnrollment.activeEnrollmentCertificates).concat(Object.values(props.physician.currentCCEnrollment.futureEnrollmentCertificates));
    let sortedEnrollmentCertificates = activeAndFutureEnollmentCertificates && activeAndFutureEnollmentCertificates.sort((a: EnrollmentCertificate, b: EnrollmentCertificate) => {
        
        //sort by Specialty/Subspecialty
        const aCertificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == a.certificateId);
        const bCertificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == b.certificateId);
        if (!aCertificate || !bCertificate) return 0;

        if (aCertificate.isPrimary === bCertificate.isPrimary) {
            //then by recent Award Date
            return getDateWithOffset(aCertificate.awardDate).getTime() - getDateWithOffset(bCertificate.awardDate).getTime();
        } else {
            return aCertificate.isPrimary ? -1 : 1
        }
    });

    return(
        <Card className="mb-4 pp-pathway-card" border="pp-secondary-grey" bg="pp-background">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <Row>
                            <Col xs={10}>
                                <span className="text-uppercase">
                                    CONTINUING CERTIFICATION ASSESSMENT ENROLLMENT
                                </span>
                            </Col>
                            <Col className="mb-2">
                                <Link to={`ManageCCEnrollment`}><Button variant="pp-primary">Change CC Assessment Pathways</Button></Link>
                            </Col>
                        </Row>
                    </Card.Title>
                    <Row>
                        <Col>
                            {isEnrolledinCC && 
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Row>
                                                    <Col><div className="pp-font-size-smaller">Successfully complete Article-Based Pathway every 3-year block or pass CC/recertification exam every 10 years for each certification.</div></Col>
                                                </Row>
                                                <Row className="ccenrollment-pathwayoptions">
                                                    <Col>
                                                        <Row>
                                                            <Col>
                                                                <Row className="ccenrollment-pathwayoptions-header">
                                                                    <Col>CC Exams</Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col><div className="pp-font-size-smaller">Exam every 10 years. <a href="https://abpn.org/maintain-certification/taking-a-moc-exam/">Learn more</a>.</div></Col>
                                                                </Row>
                                                            </Col>
                                                            <Col>
                                                                <Row className="ccenrollment-pathwayoptions-header">
                                                                    <Col>ABCC Pathway</Col>
                                                                </Row>
                                                                <Row>
                                                                    <Col>
                                                                    <div className="pp-font-size-smaller">Successfully complete article exams every 3-year block. 
                                                                        **Starting in 2025, diplomates must successfully complete 20 article exams per certification 
                                                                        every 3-year cycle.** <a href="https://abpn.org/continuing-certification/article-based-continuing-certification-pathway-abcc/">Learn more</a>.</div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    <Row>
                                        <Col className="mb-2 font-weight-bold">Certificates enrolled in the Continuing Certification (CC) Program</Col>
                                    </Row>
                                        {sortedEnrollmentCertificates.map((enrollmentCertificate: EnrollmentCertificate) => {
                                            return (<Row>
                                                <Col>
                                                    <CCEnrollmentCertficateSummaryCard physician={props.physician} ccEnrollmentCertificate={enrollmentCertificate} abccAssessments={props.abccAssessments} acceptAbccModuleAttestation={props.acceptAbccModuleAttestation} appliedArticleWaivers={props.appliedArticleWaivers} />
                                                </Col>
                                            </Row>)
                                            
                                        })}
                                    </Col>
                                </Row>
                                }

                            {!isEnrolledinCC && lifeTimeActiveCertificates?.length > 0 &&
                                <div>
                                    <p>You are not currently enrolled in the Continuing Certification (CC) Program</p>
                                    <Link to={`ManageCCEnrollment`}><Button variant="pp-primary">Enroll in CC</Button></Link>
                                </div>
                            }
                        </Col>    
                    </Row>
                </Card.Body>
        </Card>
    );

}